import { useTranslation } from 'react-i18next';

/**
 * Placeholder for the franchise-admin Products area (`/admin/products`). The full passes
 * management surface lands in a later slice; for now this confirms the route + sidebar wiring.
 */
export function AdminProductsPage() {
  const { t } = useTranslation('common');
  return (
    <section className="grid gap-2 p-6">
      <h1 className="text-2xl font-semibold">{t('nav.products')}</h1>
      <p className="text-muted-foreground">{t('admin.comingSoon')}</p>
    </section>
  );
}
